// extracted by mini-css-extract-plugin
export default {"perfil":"Perfil_perfil__Kn+de","datos":"Perfil_datos__Oh8Ba","foto":"Perfil_foto__z1QFO","detalles":"Perfil_detalles__d0xNd","detalles_texto":"Perfil_detalles_texto__McalW"};